/** Entry point for the AccessScore tool. */
import { AccessScoreApp } from '../access-score/main.js';
import { viewerClassFor } from '../common/pano-viewer/viewerClassFor.js';
import '../../css/components/filter-sidebar.css';
import '../../css/components/map-frame.css';
import '../../css/pages/access-score.css';

const data = document.getElementById('page-entry').dataset;
const src = data.imagerySource;
// Gets all translations before building the page.
window.appManager.ready(() => {
  AccessScoreApp.start({
    mapboxApiKey: data.mapboxApiKey,
    viewerType: viewerClassFor(src),
    imageryAccessToken: data.imageryAccessToken,
    // The view sends a username only for a real account; anonymous sessions have autogenerated ones.
    username: data.username || null,
  });
});
